// Ekran 09 — storno onay drawer'ı.
//
// Referansta storno butonu doğrudan çalışıyor, onay adımı YOK. Burada bir adım
// var çünkü sunucu gerekçesiz stornoyu 409 ile reddediyor (K15): ters kayıt
// kalıcıdır ve nedeni denetim izinde yazılı olmak zorunda. Onaysız bir buton
// ya gerekçeyi uydururdu ya da her tıklamada hata verirdi.

import { useState } from 'react'
import { DrawerAltlik, DrawerGovde, useDrawer } from '../../components/Drawer'

export default function StornoDrawer({
  belgeNo,
  bekliyor,
  onay,
}: {
  belgeNo: string
  bekliyor: boolean
  onay: (gerekce: string) => void
}) {
  const { kapat } = useDrawer()
  const [gerekce, setGerekce] = useState('')

  return (
    <>
      <DrawerGovde>
        <div
          className="info-box"
          style={{
            background: 'var(--amber-bg)',
            borderColor: 'var(--amber-bd)',
            color: 'var(--amber)',
          }}
        >
          <div>
            <b>{belgeNo}</b> silinmeyecek. Ters kayıt (<b>{belgeNo}-S</b>) üretilir,
            havuz bakiyesi geri alınır ve orijinal satır denetim izinde soluk
            görünür (K15 · K39).
          </div>
        </div>

        <div className="fld" style={{ marginTop: 10 }}>
          <label>Gerekçe (zorunlu)</label>
          <input
            className="in"
            placeholder="Örn. pH 3,1 — aşırı asit, kabul reddedildi"
            value={gerekce}
            onChange={(e) => setGerekce(e.target.value)}
            autoFocus
          />
          <div className="fld-hint">Denetim izine bu metin yazılır.</div>
        </div>
      </DrawerGovde>

      <DrawerAltlik>
        <button className="btn btn-sec" type="button" onClick={() => kapat()}>
          Vazgeç
        </button>
        <button
          className="btn btn-danger"
          type="button"
          disabled={gerekce.trim() === '' || bekliyor}
          title={gerekce.trim() === '' ? 'Gerekçe zorunlu (K15)' : undefined}
          onClick={() => {
            onay(gerekce.trim())
            kapat()
          }}
        >
          {bekliyor ? 'Oluşturuluyor…' : 'Storno oluştur'}
        </button>
      </DrawerAltlik>
    </>
  )
}
